import React from 'react';
import config from "../../data/siteConfig"
const copyrightYear = () => {
  const now = new Date()
  return now.getFullYear()
}

const Footer = () => (
  <footer className="footer">
    <section className="top">
      <div className="row">
        <div className="small-12 medium-4 columns">
          <p className="uppercase">
            <strong><i className="fa fa-phone" /> Call us</strong>
          </p>
          <p className="lighter">{config.sitePhone}</p>
        </div>
        <div className="small-12 medium-4 columns">
          <p className="uppercase">
            <strong><i className="fa fa-envelope" /> Email us</strong>
          </p>
          <p className="lighter"><a href={`mailto:${config.siteEmail}`}>{config.siteEmail}</a></p>
        </div>
        <div className="small-12 medium-4 columns">
          <p className="uppercase">
            <strong><i className="fa fa-map-marker" /> Visit us</strong>
          </p>
          <p className="lighter">{config.siteAddressShort}</p>
        </div>
      </div>
    </section>
    <section className="bottom">
      <div className="row">
        <div className="small-12 medium-8 columns">
          <ul className="social-icon-list with-colors">
            <li className="fb">
              <a href="https://www.facebook.com/4x4DrivingSchool"><i className="fa fa-fw fa-facebook"></i></a>
            </li>
            <li className="tw">
              <a href="https://twitter.com/School4x4"><i className="fa fa-fw fa-twitter"></i></a>
            </li>
            <li className="in">
              <a href="https://www.instagram.com/4x4drivingschool.cardiff"><i className="fa fa-fw fa-instagram"></i></a>
            </li>
          </ul>
        </div>
        <div className="small-12 medium-4 columns">
          <p className="lighter copyright">Copyright © {copyrightYear()}</p>
        </div>
      </div>
    </section>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js